import useShowUsers from "@/services/store/useShowUsers";
import Command from "@components/Command";
import EventMap from "@components/EventMap";
import UserList from "@components/Users";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, IconButton, Slide, Stack } from "@mui/material";
import { useRef } from "react";

const Home = () => {
  const ref = useRef(null);

  const { showUsers, toggleShowUSers } = useShowUsers((state) => state);

  const right = showUsers ? 515 : 10;

  return (
    <Stack direction="row" sx={{ height: "100%", width: "100%", position: "relative" }}>
      <Box sx={{ height: "100%", width: "100%" }}>
        <EventMap />
      </Box>
      <Box
        sx={{
          position: "absolute",
          right,
          top: 10,
          background: (theme) => theme.palette.secondary.main,
          borderRadius: "50%",
          transition: "right 0.2s ease-in-out",
        }}>
        <IconButton size="small" onClick={toggleShowUSers}>
          {showUsers ? (
            <KeyboardArrowRightIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
          ) : (
            <KeyboardArrowLeftIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
          )}
        </IconButton>
      </Box>
      <Slide in={showUsers} direction="left">
        <Stack
          direction="row"
          spacing={1}
          sx={{
            position: "absolute",
            width: 500,
            height: "100%",
            transform: "translate(0, -50%)",
            right: 10,
            m: 0,
            padding: "8px 0",
            boxSizing: "border-box",
          }}>
          <Box sx={{ height: "100%", position: "relative", width: "80%" }}>
            <UserList />
          </Box>

          <Box width="20%" height="100%">
            <Command commandRef={ref} />
          </Box>
        </Stack>
      </Slide>
    </Stack>
  );
};

export default Home;
